import React, { ReactNode } from 'react';
import './Section.css';
import '../styles/styles.css'
import './Stack.css'

interface SectionProps {
  children: ReactNode;
  style?: React.CSSProperties; // Added type here
  hug?: boolean;
  height?: 'fill' | 'hug';
  width?: 'fill' | 'hug';
  className?: string;
}

const Section: React.FC<SectionProps> = ({ className, children, style, width = 'fill', height = 'hug' }) => {
  const sectionClasses = `section v-stack width-${width} height-${height} ${className && `${className}`} ungroup`;

  return (
    <div className={sectionClasses} style={style}>
      {children}
    </div>
  );
};

export { Section };
